module.exports = __webpack_public_path__ + "static/image12@2x-5dbee0a6908c3cfce755a06991c1c040.png";